export default __webpack_public_path__ + "static/media/logo.b49f47d8.svg";